export default [] as { path: string; id: number; }[];
